import React from 'react';

const Loading = () => (
	<div className='loading__container'>
		<img src='https://upload.wikimedia.org/wikipedia/commons/b/b1/Loading_icon.gif' alt='spin' />
	</div>
);

export default Loading;